module.exports = __webpack_public_path__ + "img/26.03b7a469.gif";